import { Controller } from "stimulus"
import Quill from "quill"
import "quill/dist/quill.snow.css"

export default class extends Controller {
  connect() {
    console.log('Quill editor controller connected')

    // Find editor and input elements using querySelector instead of targets
    const editorElement = this.element.querySelector('[data-quill-editor-target="editor"]')
    const inputElement = this.element.querySelector('[data-quill-editor-target="input"]')

    if (!editorElement) {
      console.error('Quill editor element not found')
      return
    }

    // Store references
    this.editorElement = editorElement
    this.inputElement = inputElement

    // Initialize Quill
    this.quill = new Quill(editorElement, {
      theme: 'snow',
      modules: {
        toolbar: [
          [{ 'header': [1, 2, 3, false] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          [{ 'color': [] }, { 'background': [] }],
          [{ 'align': [] }],
          ['link', 'image'],
          ['clean']
        ]
      },
      placeholder: editorElement.dataset.placeholder || 'Compose your email...'
    })

    console.log('Quill initialized successfully')

    // Load initial content if exists
    if (inputElement && inputElement.value && inputElement.value.trim()) {
      const delta = this.quill.clipboard.convert(inputElement.value)
      this.quill.setContents(delta, 'silent')
    }

    // Sync content to hidden input on change
    this.quill.on('text-change', () => {
      if (inputElement) {
        inputElement.value = this.quill.root.innerHTML
      }
    })
  }

  // Method to set content programmatically (for AI improvements)
  setContent(html) {
    if (this.quill) {
      // Use Quill's clipboard API to set HTML content properly
      // This avoids the internal state issues with direct innerHTML manipulation
      const delta = this.quill.clipboard.convert(html)
      this.quill.setContents(delta, 'silent')

      // Update the hidden input
      if (this.inputElement) {
        this.inputElement.value = this.quill.root.innerHTML
      }
    }
  }

  // Method to get content
  getContent() {
    if (this.quill && this.quill.root) {
      return this.quill.root.innerHTML
    }
    return ''
  }

  disconnect() {
    if (this.quill) {
      this.quill = null
    }
  }
}
